const notify = (options) => {
  $.notify(options);
};

export default notify;
